import type { CourseTreeNode } from "@/types/generated";
import type { VideoStoryboard } from "@/types/storyboard";
import VideoElement from "@/components/storyboard/video/VideoElement";
import { StoryboardFallback } from "@/components/storyboard/StoryboardFallback";

interface Props {
  data: VideoStoryboard;
  contentElement: CourseTreeNode;
}

export const StoryboardVideoRenderer = ({ data, contentElement }: Props) => {
  switch (data.subType) {
    case "EXTERNAL_VIDEO":
      return <VideoElement video={data.video} />;
    default:
      return <StoryboardFallback title={contentElement.title} />;
  }
};
